import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function AddUser() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit, } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-3 "  >
            {/* SEO SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>SEO META</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div className="flex flex-col">
                    <Label label="Meta Title" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_title" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Keywords" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_keyword" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Slug Url" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_slug_url" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col col-span-3 ">
                    <Label label="Meta Description" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_desc" rootClassName="w-full" as={"textarea"} rows={3} />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>{`${values.hero_banner.heading.white} ${values.hero_banner.heading.orange} Hero Banner` || "Hero Banner"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pb-3 border-b border-gray-100">
                  <div>
                    <Label label="Heading (White)" className="mb-1 font-semibold" />
                    <FormikInput name="hero_banner.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1 font-semibold" />
                    <FormikInput name="hero_banner.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1 font-semibold" />
                    <FormikInput name="hero_banner.subHeading" placeholder="Sub Heading" />
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pb-3 border-b border-gray-100">
                  <div>
                    <Label label="CTA Title" className="mb-1 font-semibold" />
                    <FormikInput name="hero_banner.cta_title" placeholder="e.g. Download Brochure" />
                  </div>
                  <div>
                    <Label label="CTA Download Asset (PDF)" className="mb-1 font-semibold" />
                    <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                      title="Asset"
                      imageUrl={values.hero_banner?.cta_download}
                      onChange={(res) => setFieldValue("hero_banner.cta_download", res?.data?.file_url)}
                    />
                  </div>
                  <div>
                    <Label label="CTA Download Asset (PDF)" className="mb-1 font-semibold" />
                    <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                      title="Asset"
                      imageUrl={values.hero_banner?.cta_download_second}
                      onChange={(res) => setFieldValue("hero_banner.cta_download_second", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  <div>
                    <Label label="Hero Context Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="hero_banner.paragraphs">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Sentence / Paragraph</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.hero_banner?.paragraphs?.map((content, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r">
                                    <FormikTextarea name={`hero_banner.paragraphs.${index}`} rootClassName="w-full" className="text-sm !h-24" />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                      <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-4">
                            <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push("")}>
                              + Add Paragraph Layer
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  <div>
                    <Label label="Main Hero Visual" className="mb-2 text-[#1e1e5c] font-semibold" />
                    <div className="border border-dashed border-gray-200 rounded-2xl p-2 bg-gray-50/30">
                      <ImageUploader
                        imgStyle={{ width: "100%", height: "280px", borderRadius: "12px" }}
                        imageUrl={values.hero_banner?.image}
                        onChange={(res) => setFieldValue("hero_banner.image", res?.data?.file_url)}
                      />
                      <div className="mt-2 text-[10px] text-gray-400 text-center uppercase font-bold tracking-wider">Recommended: 1920x1080px (PNG/JPG)</div>
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>{`${values?.energy_solutions?.heading?.white} ${values?.energy_solutions?.heading?.orange} Energy Solutions` || "Energy Solutions (Residential / Industrial Blocks)"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
                  <div>
                    <Label label="Heading (White)" className="mb-1" />
                    <FormikInput name="energy_solutions.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="energy_solutions.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="energy_solutions.subHeading" placeholder="Sub Heading" />
                  </div>
                </div>

                <div className="mb-6">
                  <Label label="Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="energy_solutions.para">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Sentence / Paragraph</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y bg-white">
                            {values.energy_solutions?.para?.map((content, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r">
                                  <FormikTextarea name={`energy_solutions.para.${index}`} rootClassName="w-full" className="text-sm !h-20" />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-2 text-left">
                          <Button type="button" variant="outline" className="!py-1 !px-3 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                            + Add Paragraph
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <Label label="Energy Solution Sections" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                <FieldArray name="energy_solutions.sections">
                  {(arrayHelpers) => (
                    <div className="overflow-x-auto ">
                      <div className="flex justify-end py-1 ">
                        <Button
                          type="button" variant="outline"
                          onClick={() => arrayHelpers.push({ title: "", align: "", image: "", alt: "", })}
                        >
                          + Add Section
                        </Button>
                      </div>
                      <table className="w-full border border-gray-300 rounded-lg">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-2 border">Title</th>
                            <th className="p-2 border">Button CTA</th>
                            <th className="p-2 border">Button Link</th>
                            <th className="p-2 border">Align</th>
                            <th className="p-2 border">Alt</th>
                            <th className="p-2 border">Image</th>
                            <th className="p-2 border">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.energy_solutions?.sections?.map((section, index) => (
                            <tr key={index} className="text-center">
                              <td className="p-2 border">
                                <FormikInput name={`energy_solutions.sections.${index}.title`} placeholder="Title" />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`energy_solutions.sections.${index}.btn_cta`} placeholder="Button CTA" />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`energy_solutions.sections.${index}.btn_link`} placeholder="Button Link" />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`energy_solutions.sections.${index}.align`} placeholder="left/right" />
                              </td>
                              <td className="p-2 border">
                                <FormikInput name={`energy_solutions.sections.${index}.alt`} placeholder="Alt" />
                              </td>
                              <td className="p-2 border">
                                <ImageUploader imgStyle={{ width: "50px", height: "50px" }}
                                  imageUrl={section.image}
                                  onChange={(res) => setFieldValue(`energy_solutions.sections.${index}.image`, res?.data?.file_url)}
                                />
                              </td>

                              <td className="p-2 border">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-500"                                  >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="w-full">
              <Accordion.Header>{`${values?.about_us?.heading?.white} ${values?.about_us?.heading?.orange}` || "About Us Section"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div>
                    <Label label="Heading (White)" className="mb-1" />
                    <FormikInput name="about_us.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="about_us.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="about_us.sub_heading" placeholder="Sub Heading" as="textarea" />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <div className="mt-2">
                    <Label label="Description" className="mb-1" />
                    <FormikTextarea name="about_us.desc" placeholder="Description" />
                  </div>
                  <div className="mt-2">
                    <Label label="Sub Description" className="mb-1" />
                    <FormikTextarea name="about_us.sub_desc" placeholder="Sub Description" />
                  </div>
                </div>

                <div className="mt-3">
                  <Label label="Features Cards" className="mb-2 font-semibold" />
                  <FieldArray name="about_us.cards">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-300 rounded-lg">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="p-2 border">Icon</th>
                              <th className="p-2 border">Text</th>
                              <th className="p-2 border">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.about_us?.cards?.map((card, index) => (
                              <tr key={index} className="text-center">
                                <td className="p-2 border">
                                  <ImageUploader imgStyle={{ width: "60px", height: "60px" }} imageUrl={card.icon} onChange={(res) => setFieldValue(`about_us.cards.${index}.icon`, res?.data?.file_url)} />
                                </td>
                                <td className="p-2 border">
                                  <Label label="Card Text" className="mb-1 block text-left" />
                                  <FormikInput name={`about_us.cards.${index}.text`} placeholder="Card Text" />
                                </td>
                                <td className="p-2 border align-middle">
                                  <FontAwesomeIcon size={22} color="red" icon={faTrash} onClick={() => arrayHelpers.remove(index)} className="hover:bg-red-500 hover:text-white p-2 rounded-full cursor-pointer transition-all duration-300" />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="mt-3">
                          <Button type="button" variant="outline" onClick={() => arrayHelpers.push({ icon: "", text: "", })}>
                            + Add Card
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="mt-3">
                  <Label label="Bottom Paragraph" className="mb-1" />
                  <FormikTextarea name="about_us.bottom_para" placeholder="Bottom Paragraph" />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className="w-full">
              <Accordion.Header>{`${values?.residential_industrial?.heading?.white} ${values?.residential_industrial?.heading?.orange}` || "Residential & Industrial"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                  <div>
                    <Label label="Heading (White)" className="mb-1" />
                    <FormikInput name="residential_industrial.heading.white" placeholder="Main Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="residential_industrial.heading.orange" placeholder="Main Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="residential_industrial.sub_heading" placeholder="Sub Heading" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Description" className="mb-1" />
                    <FormikTextarea name="residential_industrial.description" placeholder="Description" />
                  </div>
                </div>

                <FieldArray name="residential_industrial.sections">
                  {(arrayHelpers) => (
                    <div className="space-y-3">
                      <div className="flex justify-end bg-gray-50 p-2 rounded-lg border border-dashed border-gray-200">
                        <Button type="button" variant="outline" onClick={() => arrayHelpers.push({ title: "", highlight: "", sub_title: "", description: "", image: "", checklist: [], features: [], cta_title: "", cta_link: "" })}>
                          + Add New Section Block
                        </Button>
                      </div>
                      <Accordion alwaysOpen>
                        {values.residential_industrial?.sections?.map((section, index) => (
                          <Accordion.Item eventKey={String(index)} key={index} className="mb-3 border rounded-xl shadow-sm overflow-hidden">
                            <Accordion.Header className="bg-gray-50/50">
                              <span className="font-bold text-[#1e1e5c]">{`${section.title} ${section.highlight}` || `Block ${index + 1}`}</span>
                            </Accordion.Header>
                            <Accordion.Body className="bg-white">
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
                                <div className="grid grid-cols-2 gap-2">
                                  <div>
                                    <Label label="Title" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.title`} placeholder="Title" />
                                  </div>
                                  <div>
                                    <Label label="Highlight" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.highlight`} placeholder="Highlight" />
                                  </div>
                                  <div>
                                    <Label label="Sub Title" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.sub_title`} placeholder="Sub Title" as="textarea" rows={2} />
                                  </div>
                                  <div>
                                    <Label label="Advantages Title" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.advantages_title`} placeholder="Advantages Title" as="textarea" rows={2} />
                                  </div>
                                  <div>
                                    <Label label="CTA Title" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.cta_title`} placeholder="e.g. Learn More" />
                                  </div>
                                  <div>
                                    <Label label="CTA Link" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.cta_link`} placeholder="e.g. /residential" />
                                  </div>
                                </div>
                                <div className="flex flex-col gap-3">
                                  <div>
                                    <Label label="Main Image" className="mb-1" />
                                    <ImageUploader
                                      imgStyle={{ width: "100%", height: "180px" }}
                                      imageUrl={section.image}
                                      onChange={(res) => setFieldValue(`residential_industrial.sections.${index}.image`, res?.data?.file_url)}
                                    />
                                  </div>
                                  <div>
                                    <Label label="Image Alt Tag" className="mb-1" />
                                    <FormikInput name={`residential_industrial.sections.${index}.image_alt`} placeholder="Image Alt Tag" />
                                  </div>
                                </div>
                                <div className="col-span-2 space-y-3">
                                  <div>
                                    <Label label="Section Description" className="mb-1" />
                                    <FormikTextarea name={`residential_industrial.sections.${index}.description`} placeholder="Description" />
                                  </div>
                                  <div>
                                    <Label label="Extra Description" className="mb-1" />
                                    <FormikTextarea name={`residential_industrial.sections.${index}.extra_description`} placeholder="Extra Description" />
                                  </div>
                                  <div>
                                    <Label label="Bottom Description" className="mb-1" />
                                    <FormikTextarea name={`residential_industrial.sections.${index}.bottom_description`} placeholder="Bottom Description" />
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 pt-6 border-t border-gray-100">
                                {/* Checklist Table */}
                                <div>
                                  <Label label="Checklist Items" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                                  <FieldArray name={`residential_industrial.sections.${index}.checklist`}>
                                    {(cHelpers) => (
                                      <div className="overflow-x-auto">
                                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                                          <thead className="bg-gray-50 border-b">
                                            <tr>
                                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Point Text</th>
                                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y">
                                            {section?.checklist?.map((item, i) => (
                                              <tr key={i} className="hover:bg-gray-50/50 transition-colors">
                                                <td className="p-2 border-r">
                                                  <FormikInput name={`residential_industrial.sections.${index}.checklist.${i}.text`} placeholder="Point text..." className="text-sm" />
                                                </td>
                                                <td className="p-2 text-center">
                                                  <button type="button" onClick={() => cHelpers.remove(i)} className="text-red-400 hover:text-red-600 transition-colors">
                                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                            {(!section?.checklist || section?.checklist.length === 0) && (
                                              <tr>
                                                <td colSpan="2" className="p-4 text-center text-gray-400 text-xs italic">No items added yet.</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        <div className="mt-2 text-left">
                                          <Button type="button" variant="outline" className="!py-1 !px-3 !text-[11px]" onClick={() => cHelpers.push({ text: "" })}>
                                            + Add Point
                                          </Button>
                                        </div>
                                      </div>
                                    )}
                                  </FieldArray>
                                </div>

                                {/* Features Table */}
                                <div>
                                  <Label label="Features (Icon + Text)" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                                  <FieldArray name={`residential_industrial.sections.${index}.features`}>
                                    {(fHelpers) => (
                                      <div className="overflow-x-auto">
                                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                                          <thead className="bg-gray-50 border-b">
                                            <tr>
                                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Icon</th>
                                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Feature Label</th>
                                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                                            </tr>
                                          </thead>
                                          <tbody className="divide-y">
                                            {section.features?.map((item, i) => (
                                              <tr key={i} className="hover:bg-gray-50/50 transition-colors">
                                                <td className="p-2 border-r w-24">
                                                  <ImageUploader
                                                    imgStyle={{ width: "40px", height: "40px" }}
                                                    imageUrl={item.icon}
                                                    onChange={(res) => setFieldValue(`residential_industrial.sections.${index}.features.${i}.icon`, res?.data?.file_url)}
                                                  />
                                                </td>
                                                <td className="p-2 border-r">
                                                  <FormikInput name={`residential_industrial.sections.${index}.features.${i}.text`} placeholder="Feature description..." className="text-sm" />
                                                </td>
                                                <td className="p-2 text-center">
                                                  <button type="button" onClick={() => fHelpers.remove(i)} className="text-red-400 hover:text-red-600 transition-colors">
                                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                            {(!section.features || section.features.length === 0) && (
                                              <tr>
                                                <td colSpan="3" className="p-4 text-center text-gray-400 text-xs italic">No features added yet.</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                        <div className="mt-2 text-left">
                                          <Button type="button" variant="outline" className="!py-1 !px-3 !text-[11px]" onClick={() => fHelpers.push({ text: "", icon: "" })}>
                                            + Add Feature
                                          </Button>
                                        </div>
                                      </div>
                                    )}
                                  </FieldArray>
                                </div>
                              </div>

                              <div className="mt-8 pt-4 border-t border-gray-100 flex justify-end">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="flex items-center gap-2 text-red-500 hover:text-red-700 font-bold text-xs uppercase tracking-wider transition-all">
                                  <FontAwesomeIcon icon={faTrash} />
                                  Delete This Entire Block
                                </button>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className="w-full">
              <Accordion.Header>{`${values?.why_enclave?.heading} ${values?.why_enclave?.heading_orange}` || "Why Enclave"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
                  <div>
                    <Label label="Heading" className="mb-1" />
                    <FormikInput name="why_enclave.heading" placeholder="Heading" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="why_enclave.heading_orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="why_enclave.sub_heading" placeholder="Sub Heading" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Main Description" className="mb-1" />
                    <FormikTextarea name="why_enclave.description" placeholder="Description" />
                  </div>
                  <div>
                    <Label label="Drivers Title" className="mb-1" />
                    <FormikInput name="why_enclave.drivers_title" placeholder="Drivers Title" />
                  </div>
                </div>

                <div className="mt-2 mb-2">
                  <Label label="Planning Drivers" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="why_enclave.drivers">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Driver Point Text</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.why_enclave?.drivers?.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                                <td className="p-2 border-r">
                                  <FormikTextarea name={`why_enclave.drivers.${index}.text`} rootClassName="w-full" className="text-sm !h-20" />
                                </td>
                                <td className="p-2 text-center">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-2">
                          <Button type="button" variant="outline" className="!py-1 !px-3 !text-[11px]" onClick={() => arrayHelpers.push({ text: "" })}>
                            + Add Driver
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4 border-t border-gray-100">
                  <div>
                    <Label label="Impact Statement 1" className="mb-1" />
                    <FormikTextarea name="why_enclave.bottom_para_1" placeholder="Impact Text 1" />
                  </div>
                  <div>
                    <Label label="Impact Statement 2" className="mb-1" />
                    <FormikTextarea name="why_enclave.bottom_para_2" placeholder="Impact Text 2" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6" className="w-full">
              <Accordion.Header>{`${values?.location_section?.heading} ${values?.location_section?.heading_orange}` || "Infrastructure & Location Advantage"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
                  <div>
                    <Label label="Heading" className="mb-1" />
                    <FormikInput name="location_section.heading" placeholder="Heading" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="location_section.heading_orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="location_section.sub_heading" placeholder="Sub Heading" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Full Description" className="mb-1" />
                    <FormikTextarea name="location_section.description" placeholder="Description" />
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-2 mb-3">
                  <div className="bg-gray-50/50 p-4 rounded-xl border border-dashed border-gray-200">
                    <Label label="Map Image" className="mb-1" />
                    <ImageUploader
                      imgStyle={{ width: "100%", height: "300px" }}
                      imageUrl={values.location_section?.map_image}
                      onChange={(res) => setFieldValue("location_section.map_image", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-2">
                  <div>
                    <Label label="Location Specific Content (Tabs)" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="location_section.tabs">
                      {(arrayHelpers) => (
                        <div className="space-y-2">
                          {values.location_section?.tabs?.map((tab, index) => (
                            <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow">
                              <div className="bg-gray-100/80 px-2 py-2 border-b flex justify-between items-center">
                                <span className="font-bold text-[13px] text-[#1e1e5c] uppercase tracking-wider">Tab Configuration #{index + 1}</span>
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                              <div className="p-3 grid grid-cols-1 lg:grid-cols-2 gap-8">
                                <div className="space-y-4">
                                  <div className="grid grid-cols-2 gap-4">
                                    <div>
                                      <Label label="Tab Label" className="mb-1 text-[12px]" />
                                      <FormikInput name={`location_section.tabs.${index}.label`} placeholder="e.g. Residential" />
                                    </div>
                                    <div>
                                      <Label label="Tab Value/Slug" className="mb-1 text-[12px]" />
                                      <FormikInput name={`location_section.tabs.${index}.value`} placeholder="e.g. residential" />
                                    </div>
                                  </div>
                                  <div>
                                    <Label label="Tab Banner Image" className="mb-1 text-[12px]" />
                                    <ImageUploader
                                      imgStyle={{ width: "100%", height: "200px" }}
                                      imageUrl={tab?.banner_image}
                                      onChange={(res) => setFieldValue(`location_section.tabs.${index}.banner_image`, res?.data?.file_url)}
                                    />
                                  </div>
                                </div>

                                <div className="space-y-4">
                                  <div>
                                    <Label label="Content Overlay Title" className="mb-1 text-[12px]" />
                                    <FormikInput name={`location_section.tabs.${index}.title`} placeholder="Title" />
                                  </div>
                                  <div>
                                    <Label label="Key Points" className="mb-2 text-[12px] font-bold text-gray-500 uppercase tracking-tighter" />
                                    <FieldArray name={`location_section.tabs.${index}.points`}>
                                      {(pHelpers) => (
                                        <div className="overflow-x-auto border rounded-xl bg-gray-50/30">
                                          <table className="w-full text-sm">
                                            <thead>
                                              <tr className="bg-gray-50 border-b">
                                                <th className="p-2 text-left text-[10px] font-black uppercase text-gray-400">Point Text</th>
                                                <th className="p-2 w-10"></th>
                                              </tr>
                                            </thead>
                                            <tbody className="divide-y bg-white">
                                              {tab?.points?.map((point, pIndex) => (
                                                <tr key={pIndex}>
                                                  <td className="p-2">
                                                    <FormikInput name={`location_section.tabs.${index}.points.${pIndex}.text`} placeholder="Location Point" />
                                                  </td>
                                                  <td className="p-2 text-center align-middle">
                                                    <button type="button" onClick={() => pHelpers.remove(pIndex)} className="text-red-300 hover:text-red-500">
                                                      <FontAwesomeIcon icon={faTrash} size="sm" />
                                                    </button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                          <div className="p-2">
                                            <Button type="button" variant="outline" className="!py-1 !px-3 !text-[10px]" onClick={() => pHelpers.push({ text: "" })}>
                                              + Add Point
                                            </Button>
                                          </div>
                                        </div>
                                      )}
                                    </FieldArray>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="pt-2">
                            <Button type="button" variant="outline" className="!py-2 !px-6" onClick={() => arrayHelpers.push({ label: "", value: "", banner_image: "", title: "", points: [{ text: "" }] })}>
                              + Create New Tab Category
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className="w-full">
              <Accordion.Header>{`${values?.slider_section?.heading?.white} ${values?.slider_section?.heading?.orange}` || "Slider Gallery"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
                  <div>
                    <Label label="Heading (White)" className="mb-1" />
                    <FormikInput name="slider_section.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="slider_section.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="slider_section.subHeading" placeholder="Sub Heading" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Main Description" className="mb-1" />
                    <FormikTextarea name="slider_section.description" placeholder="Description" />
                  </div>
                </div>

                <Label label="Gallery Asset Blocks" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                <FieldArray name="slider_section.cards">
                  {(arrayHelpers) => (
                    <div className="overflow-x-auto">
                      <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                        <thead className="bg-gray-100 border-b">
                          <tr>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-52">Visual</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Asset Title & Caption</th>
                            <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-20">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y">
                          {values.slider_section?.cards?.map((card, index) => (
                            <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                              <td className="p-2 border-r align-top">
                                <ImageUploader
                                  imgStyle={{ width: "180px", height: "180px", objectFit: "contain" }}
                                  imageUrl={card.img}
                                  onChange={(res) => setFieldValue(`slider_section.cards.${index}.img`, res?.data?.file_url)}
                                />
                              </td>
                              <td className="p-2 border-r align-top space-y-3">
                                <div>
                                  <Label label="Title" className="mb-1" />
                                  <FormikInput name={`slider_section.cards.${index}.title`} placeholder="Card Title" />
                                </div>
                                <div>
                                  <Label label="Description" className="mb-1" />
                                  <FormikTextarea name={`slider_section.cards.${index}.desc`} placeholder="Card Description" className="!h-16" />
                                </div>
                              </td>
                              <td className="p-2 text-center align-middle">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                  <FontAwesomeIcon icon={faTrash} size="sm" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mt-4">
                        <Button type="button" variant="outline" className="!py-2 !px-4" onClick={() => arrayHelpers.push({ img: "", title: "", desc: "" })}>
                          + Add New Gallery Card
                        </Button>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8" className="w-full">
              <Accordion.Header>{`${values?.logo_slider?.heading?.white} ${values?.logo_slider?.heading?.orange}` || "Brand Logos Slider"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
                  <div>
                    <Label label="Heading (White)" className="mb-1" />
                    <FormikInput name="logo_slider.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="logo_slider.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1" />
                    <FormikInput name="logo_slider.subHeading" placeholder="Sub Heading" />
                  </div>
                </div>

                <div className="mb-6">
                  <Label label="Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="logo_slider.para">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Sentence / Paragraph</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y bg-white">
                            {values.logo_slider?.para?.map((content, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r">
                                  <FormikTextarea name={`logo_slider.para.${index}`} rootClassName="w-full" className="text-sm !h-20" />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-2 text-left">
                          <Button type="button" variant="outline" className="!py-1 !px-3 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                            + Add Paragraph
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <Label label="Brand Logo Collection" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                <FieldArray name="logo_slider.logos">
                  {(arrayHelpers) => (
                    <div className="overflow-x-auto">
                      <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                        <thead className="bg-gray-50 border-b">
                          <tr>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-52">Logo</th>
                            <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Metadata (Alt Tag)</th>
                            <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-20">Action</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y bg-white">
                          {values.logo_slider?.logos?.map((item, index) => (
                            <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                              <td className="p-2 border-r align-middle">
                                <ImageUploader
                                  imgStyle={{ width: "100px", height: "100px", objectFit: "contain" }}
                                  imageUrl={item.image}
                                  onChange={(res) => setFieldValue(`logo_slider.logos.${index}.image`, res?.data?.file_url)}
                                />
                              </td>
                              <td className="p-2 border-r align-middle">
                                <FormikInput name={`logo_slider.logos.${index}.alt`} placeholder="Company Name / Alt text" className="text-sm" />
                              </td>
                              <td className="p-2 text-center align-middle">
                                <button type="button" onClick={() => arrayHelpers.remove(index)} className=" hover:cursor-pointer hover:bg-gray-100 p-2 rounded-full text-red-400 hover:text-red-600 transition-colors">
                                  <FontAwesomeIcon icon={faTrash} size="sm" />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="mt-4">
                        <Button type="button" variant="outline" className="!py-2 !px-4" onClick={() => arrayHelpers.push({ image: "", alt: "" })}>
                          + Add New Brand Logo
                        </Button>
                      </div>
                    </div>
                  )}
                </FieldArray>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9" className="w-full">
              <Accordion.Header>{"Footer Banner Image"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 mb-6">
                  <Label label="Footer Banner Image" className="mb-1" />
                  <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                    title="Footer Banner Image"
                    imageUrl={values.footer_bgimg}
                    onChange={(res) => setFieldValue("footer_bgimg", res?.data?.file_url)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button type="submit" label="SAVE CHANGES" />
          </div>
        </Form>
      )}
    </Formik>
  );
}
